import React from 'react';
import Button from '@mui/material/Button';
import BotaoVoltar from "./common/botaoVoltar";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DistVafCircularProgress from "./common/distVafCircularProgress";
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import $ from 'jquery'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import fetchWithToken from 'config/UseFetchWithToken';


import {URL_API} from '../config/urls'

const mensagemFormatada = `<!DOCTYPE html>
<html lang="pt">
	<head>
		<title>DISTVAF -Secretaria de Estado de Fazenda de Minas Gerais</title>
		<meta charset="utf-8"/>
		<link rel="preconnect" href="https://fonts.googleapis.com">
		<link rel="preconnect" href="https://fonts.gstatic.com">
		<link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,500,600,400italic,600italic|Roboto+Slab:400,700" rel="stylesheet">
	</head>
	<body style="margin:0;padding:0;font-family:'Open Sans',Arial,sans-serif\font-size:14px;">
	<div align="center">
	<table style="background: #d9d9d9; margin: 50 0px;" border="0" width="800" cellspacing="0" cellpadding="0">
		<tbody>
		<tr>
			<td><img src="cid:image" /></td>
		</tr>
		<tr>
			<td style="padding: 16px;">
			<table style="background: #ffffff;" border="0" width="100%" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td style="padding: 100 0px;">
					<p style="text-align: center; font-size: 36pt; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;"><strong>[TITULO]</strong></p>
					</td>
				</tr>
				<tr>
					<td style="padding: 40px;">
					<p style="text-align: justify; font-size: 14pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">[MENSAGEM]</p>
					</td>
				</tr>
				<tr>
					<td style="padding: 20 0 100 0px;">
					<p style="text-align: center; font-size: 14pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">[ASSINATURA]</p>
					</td>
				</tr>
				</tbody>
			</table>
			</td>
		</tr>
		<tr>
			<td style="background: transparent; padding: 0cm 0cm 0cm 0cm;">
			<p style="text-align: center; font-size: 12pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">Belo Horizonte, [DATA]</p>
			</td>
		</tr>
		<tr>
			<td style="padding: 50 150px;">
			<p style="text-align: center; font-size: 10pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">Esta &eacute; uma mensagem gerada pelo sistema. N&atilde;o a responda.<br />Voc&ecirc; est&aacute; recebendo este e-mail como resultado<br />do seu relacionamento atual com a<br />Secretaria de Estado de Fazenda de Minas Gerais</p>
			</td>
		</tr>
		</tbody>
			</table>
		</div>
	</body>
</html>`

class Enviar extends React.Component {

	constructor(props) {

			super(props)
			this.state = {
				ano: "",
				arquivos: [],
				assinatura: "",
				assunto: "",
				corpo: "",
				dadosAf: [],
				dadosPrefeitura: [],
				dadosSrf: [],
				idsAf: [],
				idsPrefeitura: [],
				idsSrf: [],
				marcadosAf: [],
				marcadosPrefeitura: [],
				marcadosSrf: [],
				mensagem: "",
				mostraMensagem: false,
				mostraModal: false,
				nomeArquivo: "",
				parametros: [],
				qualTab: "2",
				texto: "",
				tipoArquivo: "",
				titulo: "",
				tudoAf: false,
				tudoPrefeitura: false,
				tudoSrf: false,
				loader: false,
				mensagemModal: ""
			}
		this.abrirModal = this.abrirModal.bind(this);
		this.fecharModal = this.fecharModal.bind(this);
		this.controlarItem = this.controlarItem.bind(this);
		this.controlarItemCheckAf = this.controlarItemCheckAf.bind(this);
		this.controlarItemCheckPrefeitura = this.controlarItemCheckPrefeitura.bind(this);
		this.controlarItemCheckSrf = this.controlarItemCheckSrf.bind(this);
		this.controlarItemTudoAf = this.controlarItemTudoAf.bind(this);
		this.controlarItemTudoPrefeitura = this.controlarItemTudoPrefeitura.bind(this);
		this.controlarItemTudoSrf = this.controlarItemTudoSrf.bind(this);
		this.controlarItemTudoSrf = this.controlarItemTudoSrf.bind(this);
		this.controlarSelecaoNomeArquivo = this.controlarSelecaoNomeArquivo.bind(this);
		this.controlarTabs = this.controlarTabs.bind(this);
	}

	componentDidMount() {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestOptionsGet = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/parametro/obterParametro`, requestOptionsGet)
			.then(_res => _res.json())
			.then(_res => {
				 if (_res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ assinatura: _res.find(o => o.campo === 'ENVIOASSINATURA')["valor"] })
					this.setState({ assunto: _res.find(o => o.campo === 'ENVIOASSUNTO')["valor"] })
					this.setState({ mensagem: _res.find(o => o.campo === 'ENVIOMENSAGEM')["valor"] })
				}
			})
			.catch(err => {
				console.error("Ocorreu um erro - " + err);
			})
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${token_keycloack}`, "Access-Control-Allow-Origin": "*"},
			body: "pasta=VAFRET/ATIVOS_E_RETORNOS" +
			      "&filtro=*"	  
		}
		fetchWithToken(`${URL_API}/api/v1/ftp/listarArquivos`, requestOptions)
			.then(_res => _res.json())
			.then(res => {
				 if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ arquivos: res })
					this.definirVariaveis(res[0])
				}
			})
			.catch(err => {
				console.error("Ocorreu um erro - " + err)
			})
		this.setState({ corpo: mensagemFormatada })
		fetchWithToken(`${URL_API}/api/v1/af/obterAf`, requestOptionsGet)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosAf: res })
					let itensAf = [];
					res.map((_item) => (
						itensAf[_item.codigo] = false
					))
					this.setState({ marcadosAf: itensAf })
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação.")
			});
		fetchWithToken(`${URL_API}/api/v1/prefeitura/obterPrefeitura`, requestOptionsGet)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosPrefeitura: res })
					let itensPrefeitura = [];
					res.map((_item) => (
						itensPrefeitura[_item.codigo] = false
					))
					this.setState({ marcadosPrefeitura: itensPrefeitura })
					$(document).ready(function () {
						setTimeout(function () {
							$('#tblPrefeitura').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: -1,
								language: {
									url: '/pt-BR.json'
								}
							});

							$('#tblAf').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: -1,
								language: {
									url: '/pt-BR.json'
								}
							});
							
							$('#tblSrf').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: -1,
								language: {
									url: '/pt-BR.json'
								}
							});
						}, 100);
					});
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação."+ _err)
			});
		fetchWithToken(`${URL_API}/api/v1/srf/obterSrf`, requestOptionsGet)
			.then(_res => _res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosSrf: res })
					let itensSrf = [];
					res.map((_item) => (
						itensSrf[_item.codigo] = false
					))
					this.setState({ marcadosSrf: itensSrf })
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação."+ _err)
			});
	}

	abrirModal() {
		this.setState({ mostraModal: true })
	}

	fecharModal() {
		this.setState({ mostraModal: false })
	}

	classifica(a, b) {
		if (a.nome > b.nome) { return 1; }
		if (a.nome < b.nome) { return -1; }
		return 0;
	}

	controlarItem = (e) => {
		this.setState({ [e.target.id]: e.target.value })
	}

	controlarItemCheckAf = (e) => {
		let id = e.target.id.substring(3)
		let marcadosAf = this.state.marcadosAf;
		let item = this.state.marcadosAf[id];
		marcadosAf[id] = !item;
		this.setState({ marcadosAf: marcadosAf });
		if (!item) {
			this.setState({ idsAf: [...this.state.idsAf, parseInt(id)] });
		}
		else {
			const indice = this.state.idsAf.indexOf(parseInt(id))
			this.state.idsAf.splice(indice, 1)
			this.setState({ idsAf: this.state.idsAf })
		}
	}

	controlarItemCheckPrefeitura = (e) => {
		let id = e.target.id.substring(3)
		let marcadosPrefeitura = this.state.marcadosPrefeitura;
		let item = this.state.marcadosPrefeitura[id];
		marcadosPrefeitura[id] = !item;
		this.setState({ marcadosPrefeitura: marcadosPrefeitura });
		if (!item) {
			this.setState({ idsPrefeitura: [...this.state.idsPrefeitura, parseInt(id)] });
		}
		else {
			const indice = this.state.idsPrefeitura.indexOf(parseInt(id))
			this.state.idsPrefeitura.splice(indice, 1)
			this.setState({ idsPrefeitura: this.state.idsPrefeitura })
		}
	}

	controlarItemCheckSrf = (e) => {
		let id = e.target.id.substring(3)
		let marcadosSrf = this.state.marcadosSrf;
		let item = this.state.marcadosSrf[id];
		marcadosSrf[id] = !item;
		this.setState({ marcadosSrf: marcadosSrf });
		if (!item) {
			this.setState({ idsSrf: [...this.state.idsSrf, parseInt(id)] });
		}
		else {
			const indice = this.state.idsSrf.indexOf(parseInt(id))
			this.state.idsSrf.splice(indice, 1)
			this.setState({ ids: this.state.idsSrf })
		}
	}

	controlarItemTudoAf = (e) => {
		this.setState({ tudoAf: e.target.checked })
		
		Object.keys(this.state.marcadosAf).forEach((key) => {
            this.state.marcadosAf[key] = e.target.checked;
        });

		const idsAf = [];
		if (!this.state.tudoAf) {
			this.state.dadosAf.map((item) => (
				idsAf.push(item.codigo)
			))
		}
		this.setState({ idsAf: idsAf })
	}

	controlarItemTudoPrefeitura = (e) => {
		this.setState({ tudoPrefeitura: e.target.checked })

		Object.keys(this.state.marcadosPrefeitura).forEach((key) => {
            this.state.marcadosPrefeitura[key] = e.target.checked;
        });

		const idsPrefeitura = [];
		if (!this.state.tudoPrefeitura) {
			this.state.dadosPrefeitura.map((item) => (
				idsPrefeitura.push(item.codigo)
			))
		}
		this.setState({ idsPrefeitura: idsPrefeitura })
	}

	controlarItemTudoSrf = (e) => {

		this.setState({ tudoSrf: e.target.checked })

		Object.keys(this.state.marcadosSrf).forEach((key) => {
            this.state.marcadosSrf[key] = e.target.checked;
        });
		const idsSrf = [];
		if (!this.state.tudoSrf) {
			this.state.dadosSrf.map((item) => (
				idsSrf.push(item.codigo)
			))
		}
		this.setState({ idsSrf: idsSrf })
	}

	controlarSelecaoNomeArquivo(e) {
		this.definirVariaveis(e.target.value)
	}

	desmarcarSelecoesTodasAbas() {

		this.state.tudoAf = false;
		this.state.tudoPrefeitura = false;
		this.state.tudoSrf = false;

		Object.keys(this.state.marcadosSrf).forEach((key) => {
            this.state.marcadosSrf[key] = false;
        });

		Object.keys(this.state.marcadosPrefeitura).forEach((key) => {
            this.state.marcadosPrefeitura[key] = false;
        });

		Object.keys(this.state.marcadosAf).forEach((key) => {
            this.state.marcadosAf[key] = false;
        });
	}


	controlarTabs(_e, qual) {
		this.setState({idsPrefeitura: []})
		this.setState({idsAf: []})
		this.setState({idsSrf: []})
		this.desmarcarSelecoesTodasAbas();
		this.setState({ qualTab: qual })

		setTimeout(function () {
			$('#tblPrefeitura').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],				
				language: {
					url: '/pt-BR.json'
				}
			});

			$('#tblAf').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
				paging: false,
				language: {
					url: '/pt-BR.json'
				}
			});
			
			$('#tblSrf').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
				paging: false,
				language: {
					url: '/pt-BR.json'
				}
			});
		}, 100);
	}

	definirVariaveis(valor) {
		this.setState({ nomeArquivo: valor })
	}

	enviarArquivos = (e) => {

		e.preventDefault();
		
		if (this.state.nomeArquivo === "") {
			alert("Escolha o nome do arquivo!")
			$("#cmbNomeArquivo").trigger('focus')
			return false
		}
		if (this.state.idsAf.length + this.state.idsPrefeitura.length + this.state.idsSrf.length === 0) {
			alert("Nenhum destinatário selecionado!")
			return false
		}		

		let baixar = "S"
		let gerar = "S"
		let excluir = "N"
		this.state.parametros.map(item => {
			if (item.campo === "BAIXARARQUIVO") {
				baixar = item.valor
			}
			if (item.campo === "GERARARQUIVOS") {
				gerar = item.valor
			}
			if (item.campo === "EXCLUIRARQUIVOS") {
				excluir = item.valor
			}
			return false
		})
		if(this.state.assunto === ""){
			alert("Informe o assunto do email")
			return false
		}
		if(this.state.mensagem === ""){
			alert("Informe a mensagem do email")
			return false
		}
		if(this.state.assinatura === ""){
			alert("Informe o assunto do email")
			return false
		}
		this.setState({ loader: true })

		let token_keycloack = sessionStorage.getItem('token_keycloack');

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${token_keycloack}` },
			body: "tipoArquivo=" + this.state.tipoArquivo +
				"&nomeArquivo=" + this.state.nomeArquivo +
				"&ano=" + this.state.ano +
				"&numeroRetorno=" + this.state.numeroRetorno +
				"&baixar=" + baixar +
				"&gerar=" + gerar +
				"&excluir=" + excluir +
				"&idsPrefeitura=" +this.state.idsPrefeitura +
				"&idsAf=" +this.state.idsAf +
				"&idsSrf=" +this.state.idsSrf +
				"&assunto=" +this.state.assunto +
				"&assinatura=" + this.state.assinatura +
				"&mensagemFormatada=" + encodeURIComponent(mensagemFormatada) +
				"&mensagem=" + this.state.mensagem 
		};

		fetch(`${URL_API}/api/v1/arquivo/prepararArquivos`, requestOptions)
		this.setState({
			idsPrefeitura: [],
			idsAf: [],
			idsSrf: [],
			marcadosAf: [],
			marcadosPrefeitura: [],
			marcadosSrf: [],
			tudoAf: false,
			tudoPrefeitura: false,
			tudoSrf: false,
			loader: false,
			mensagemModal: "A solicitação foi enviada para processamento. Após finalização do envio, você receberá um email."
		});
		this.abrirModal();
	}

	render() {
		return (
			<div className="container-fluid">
				
				<div className="row">
					<div className="col-12">
						<header className="main">
							<h2>DISTVAF - Envio de Arquivos</h2>
						</header>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
					</div>
					<div className="col-6">
						<BotaoVoltar />
					</div>
				</div>
				<form>
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Arquivo para importação
								</div>
								<label>Selecione o arquivo</label>
								<select name="nomeArquivo" id="cmbNomeArquivo" onChange={this.controlarSelecaoNomeArquivo}>
									{this.state.arquivos != null && this.state.arquivos.map((result) => {
										return (
											<option key={result} value={result}>{result}</option>
										);
									})}
								</select>
							</Paper>
						</div>
					</div>
					{(this.state.loader && <DistVafCircularProgress />)}
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Dados do e-mail
								</div>
								<label htmlFor="assunto" className="margem-antes" maxLength="100">Assunto</label>
								<input type="text" name="assunto" id="assunto" value={this.state.assunto} onChange={this.controlarItem} />
								<label htmlFor="mensagem" className="margem-antes">Mensagem</label>
								<textarea name="mensagem" id="mensagem" value={this.state.mensagem} onChange={this.controlarItem} rows="4" />
								<label htmlFor="assinatura" className="margem-antes">Assinatura</label>
								<textarea name="assinatura" id="assinatura" value={this.state.assinatura} onChange={this.controlarItem} rows="2" />
							</Paper>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<label className="margem-antes"></label>
							<Button variant="contained" color="primary" onClick={  (e) => this.enviarArquivos(e) }>Enviar Arquivos</Button>
						</div>
					</div><br></br>
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Seleção dos destinatários
								</div>
								<TabContext value={this.state.qualTab}>
									<TabList onChange={this.controlarTabs}>
										<Tab label="Prefeitura" value="2" />
										<Tab label="AF" value="1" />										
										<Tab label="SRF" value="3" />
									</TabList>
									<TabPanel value="1">
										<div className="table-wrapper ">
											<table id="tblAf" className="stripe row-border">
												<thead>
													<tr>
														<th className='caixa'><input type="checkbox" id="chkTudoAf" checked={this.state.tudoAf} onChange={this.controlarItemTudoAf} /><label htmlFor="chkTudoAf"> </label></th>
														<th>AF</th>
														{/* <th className='align-center'>Situação</th> */}
													</tr>
												</thead>
												<tbody>
													{this.state.dadosAf.sort(this.classifica).map((reg) => {
														return (
															<tr key={"af_" + reg.codigo}>
																<td className='caixa'><input type="checkbox" id={"af_" + reg.codigo} checked={this.state.marcadosAf[reg.codigo] || false} onChange={this.controlarItemCheckAf} value={reg.email} /><label htmlFor={"af_" + reg.codigo}></label></td>
																<td>{reg.nome}</td>
																{/*<td className='align-center' id={"situacaoAf_" + reg.codigo}>Não enviado</td> */}
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel value="2">
										<div className="table-wrapper ">
											<table id="tblPrefeitura" className="stripe row-border">
												<thead>
													<tr>
														<th className='caixa'><input type="checkbox" id="chkTudoPrefeitura" checked={this.tudoPrefeitura} onChange={this.controlarItemTudoPrefeitura} /><label htmlFor="chkTudoPrefeitura"> </label></th>
														<th>Município</th>
														<th className='align-center'>Código</th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosPrefeitura.sort(this.classifica).map((reg) => {
														return (
															<tr key={"pr_" + reg.codigo}>
																<td className='caixa'><input type="checkbox" id={"pr_" + reg.codigo} checked={this.state.marcadosPrefeitura[reg.codigo] || false} onChange={this.controlarItemCheckPrefeitura} value={reg.email} /><label htmlFor={"pr_" + reg.codigo}></label></td>
																<td>{reg.nome}</td>
																<td className='align-center'>{reg.codigo}</td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel value="3">
										<div className="table-wrapper ">
											<table id="tblSrf" className="stripe row-border">
												<thead>
													<tr>
														<th className='caixa'></th>
														<th>SRF</th>
														{/*<th className='align-center'>Situação</th> */}
													</tr>
												</thead>
												<tbody>
													{this.state.dadosSrf.sort(this.classifica).map((reg) => {
														return (
															<tr key={"sr_" + reg.codigo}>
																<td className='caixa'><input type="checkbox" id={"sr_" + reg.codigo} checked={this.state.marcadosSrf[reg.codigo] || false} onChange={this.controlarItemCheckSrf} value={reg.email} /><label htmlFor={"sr_" + reg.codigo}></label></td>
																<td>{reg.nome}</td>
																{/*<td className='align-center' id={"situacaoSrf_" + reg.codigo}>Não enviado</td> */}
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
								</TabContext>
							</Paper>
						</div>
					</div>
				</form>
				<Dialog open={this.state.mostraModal} aria-labelledby="customized-dialog-title">
					<DialogTitle id="alert-dialog-title">Processamento concluído</DialogTitle>
					<DialogContent  sx={{overflowY: 'scroll'}} >
						<DialogContentText id="alert-dialog-description" >
							O arquivo foi enviado para a unidade selecionada!<br></br><br></br>
							{this.state.mensagemModal}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant="contained" color="primary" onClick={ () => this.fecharModal() }>Ok</Button>
					</DialogActions>
				</Dialog>
			</div >
			
		)
	}
}

export default Enviar